import React, { Component } from 'react'
import { connect } from 'react-redux'
import DrawerComponent from '../../components/Drawer/DrawerComponent'
import HeaderComponent from '../../components/header/HeaderComponent'
import DoctorsList from '../../components/Doctors/DoctorsList';


import { setSelectedDrawerMenu } from '../../redux/drawer/DrawerAction';

import './DoctorsPageStyle.scss'

export class DoctorsPage extends Component {
    
    componentDidMount(){
        this.props.setSelectedDrawerMenu('doc');
        
    }
    
    render() {
        return (
            <div className='doctors-page'>
                <div className='header-box'>
                    <HeaderComponent docByUser={{}} history={this.props.history} />
                </div>
                <div className='container'>
                    <DrawerComponent />
                    <DoctorsList />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    
})

const mapDispatchToProps = dispatch =>({
    setSelectedDrawerMenu: selectedMenu => dispatch(setSelectedDrawerMenu(selectedMenu)),
    
})

export default connect(mapStateToProps, mapDispatchToProps)(DoctorsPage)
